import { motion } from "framer-motion";
import { Plane, Truck, Luggage, Handshake, Check } from "lucide-react";
import { SERVICES } from "@/data/content";

const ICONS = {
  "air-express": Plane,
  "last-mile": Truck,
  baggage: Luggage,
  forwarder: Handshake,
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="border-b border-[#E4E7EC] bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="overline mb-4" data-testid="services-eyebrow">
              § 01 — What we do
            </p>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-[#101828] sm:text-5xl md:text-6xl">
              Four services.<br />One India desk.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[#475467]">
              Every shipment landing in India needs a licensed CHA, a duty
              settlement, and a last-mile leg. We do all three — and we do them
              specifically for international freight forwarders who need a
              trustworthy India partner.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:col-span-7">
            {SERVICES.map((s, i) => {
              const Icon = ICONS[s.id] || Plane;
              return (
                <motion.article
                  key={s.id}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.5, delay: i * 0.05 }}
                  className="bento-card group flex flex-col border-2 border-[#101828] bg-[#F9FAFB] p-6"
                  data-testid={`service-card-${s.id}`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-mono-accent text-[#D92D20]">
                      {s.code} / {s.id.toUpperCase()}
                    </span>
                    <Icon className="h-6 w-6 text-[#101828]" strokeWidth={2} />
                  </div>
                  <h3 className="mt-6 font-display text-2xl font-bold leading-tight tracking-tight text-[#101828]">
                    {s.name}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#475467]">
                    {s.long}
                  </p>
                  <ul className="mt-5 space-y-2 border-t border-[#E4E7EC] pt-4">
                    {s.bullets.map((b) => (
                      <li key={b} className="flex items-start gap-2 text-sm text-[#101828]">
                        <Check className="mt-0.5 h-4 w-4 flex-none text-[#D92D20]" strokeWidth={3} />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </motion.article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
